import React, { useState, useEffect } from "react";
import "./styles.css";
import axios from "axios";
import Navbar from "../../components/Navbar";
import { DatePicker, Space, Row, Card, Col, Statistic, Button } from "antd";
import moment from "moment";
import { Typography, Modal } from "antd";
import CountUp from "react-countup";
const formatter = (value) => <CountUp end={value} separator="," />;

const { Text } = Typography;

const { RangePicker } = DatePicker;

// const dateFormat = "DD/MM/YYYY";

const configAxios = {
  withCredentials: true,
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
  },
};

const TicketsFab = () => {
  const [from, setFrom] = useState(
    `'${moment().startOf("month").format("YYYY-MM-DD")}'`
  );
  const [to, setTo] = useState(`'${moment().format("YYYY-MM-DD")}'`);
  const [range, setRange] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axios
      .post(
        "/api/data/ticketsbydaterange",
        {
          from,
          to,
        },
        configAxios
      )
      .then((response) => {
        setRange(response.data[0]);
      })
      .catch((e) => console.log(e));
  }, [to, from]);

  const handleDate = (value) => {
    console.log("value", value);
    if (value !== null) {
      setFrom(`'${moment(value[0]._d).format().split("T")[0]}'`);
      setTo(`'${moment(value[1]._d).format().split("T")[0]}'`);
    } else {
      //   props.setData("");
    }
  };

  return (
    <div className="container">
      <Navbar></Navbar>
      <div className="filterticketfab"></div>
      <div className="datepicker-container">
        <Space direction="vertical" size={15} className="datepicker">
          <Text className="dd">Rango de fechas</Text>
          <RangePicker
            format="DD-MM-YYYY"
            onChange={handleDate}
            defaultValue={[moment().startOf("month"), moment()]}
          />
        </Space>
        <Text className="dd2">
          Desde {moment(from).format("dddd DD")} Hasta{" "}
          {moment(to).format("dddd DD")}
        </Text>
      </div>

      <Row gutter={16} className="row">
        {range &&
          range.map((e) => {
            if (e.TotalAmount > 0) {
              return (
                <Col span={6}>
                  <Card className="ticket" title={e.EntityName} hoverable>
                    <Statistic
                      title={e.NewDate}
                      value={e.TotalAmount}
                      formatter={formatter}
                    />
                    <Button className="btn1" onClick={() => setOpen(true)}>
                      Mas Info
                    </Button>
                    <Modal
                      title="Ticket"
                      centered
                      mask={false}
                      open={open}
                      onOk={() => setOpen(false)}
                      onCancel={() => setOpen(false)}
                      width={500}
                    >
                      <p>some contents...</p>
                      <p>some contents...</p>
                      <p>some contents...</p>
                    </Modal>
                  </Card>
                </Col>
              );
            }
          })}
      </Row>
    </div>
  );
};

export default TicketsFab;
